import styled, { keyframes } from "styled-components";

import bgImg from "../../../assets/senai-fundo.jpg";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  background-image: url(${bgImg});
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;

  background-color: #ccc9;

  z-index: 1;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FormLogin = styled.form`
  max-width: 80%;
  width: 500px;
  height: fit-content;
  z-index: 2;
  margin: 0px 10px;
  position: relative;

  animation: ${fadeIn} 0.3s;

  background-color: var(--whiteTransparent);
  border-radius: 10px;
  color: var(--black);
  box-shadow: 0px 0px 10px;

  display: flex;
  flex-direction: column;

  > header {
    width: 100%;
    height: 180px;
    margin-top: -25px;
    border-radius: 10px 10px 0px 0px;
    background-color: #ff0000;

    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 480px) {
      height: 100px;
    }

    > img {
      width: 80%;

      @media (max-width: 480px) {
        width: 60%;
      }
    }
  }

  > section {
    display: flex;
    flex-direction: column;

    padding: 30px;

    > a {
      color: var(--black);
      font-size: 18px;
      text-decoration: none;
      text-align: center;

      margin-top: 10px;

      :hover {
        text-decoration: underline;
      }

      :active {
        opacity: 0.5;
      }
    }

    > h1 {
      font-size: 30px;
      text-align: center;
      margin-bottom: 20px;

      @media (max-width: 450px) {
        font-size: 22px;
      }
    }
  }
`;
